module.exports = __webpack_public_path__ + "img/art-slide-4-xl-me.04bd2ee.webp";